<template>
  <div class="row pt-2 back-and-skip">
    <div class="col-3 offset-lg-2 col-lg-2 text-center text-lg-left">
      <span class="back" @click="backPage">
        <img class="arrow" src="../assets/arrow-left.svg" alt="back-page">
      </span>
    </div>
    <div v-if="!hideSkip" class="offset-6 col-3 offset-lg-4 col-lg-2 text-center">
      <button class="btn btn-sm skip" @click="nextPage">
        {{ $t('general.skip') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    backPage () {
      this.$router.go(-1)
    },
    nextPage () {
      this.$router.push({
        name: this.skip
      })
    }
  },
  props: {
    skip: {
      type: String,
      default: ''
    },
    hideSkip: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.back-and-skip .back {
  border-radius: 15px;
  border: 1px solid #c2c2c2;
  padding-top: .4rem;
  padding-bottom: .5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  box-shadow: 0 0 8px #ddd;
  cursor: pointer;
  background-color: white;
}

.back-and-skip .arrow {
  width: 2.3rem;
}

.back-and-skip .skip {
  color: #c2c2c2;
  border: 1px solid #c2c2c2;
  border-radius: 5px;
  width: 100%;
}
</style>
